import { YMInitializer } from 'react-yandex-metrika';
import React from "react";

const MetrikaPixel = ({account}) => {
    return (
        <div>
            <YMInitializer accounts={[account]}/>
        </div>
    );
}

export default MetrikaPixel